"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var resolver_1 = require("./resolver");
require("@szhsin/react-menu/dist/index.css");
require("./badge-menu.css");
var react_menu_1 = require("@szhsin/react-menu");
var BadgeMenu = function (props) {
    var _a = react_1.useState(null), user = _a[0], setUser = _a[1];
    var userId = props.userId, _b = props.links, links = _b === void 0 ? [] : _b, userOverride = props.userOverride;
    console.log(userOverride);
    react_1.useEffect(function () {
        if (!user) {
            if (userOverride) {
                var user_id = userOverride.user_id, name_1 = userOverride.name;
                setUser({
                    id: user_id,
                    name: name_1,
                    imageUrl: resolver_1.default_profile_photo(name_1, user_id),
                });
            }
            else {
                var fn = function () { return __awaiter(void 0, void 0, void 0, function () {
                    var u;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4, resolver_1.UserResolver(userId)];
                            case 1:
                                u = _a.sent();
                                setUser({
                                    id: u.id,
                                    name: u.name,
                                    imageUrl: u.imageUrl,
                                });
                                return [2];
                        }
                    });
                }); };
                fn();
            }
        }
    }, []);
    if (user == null)
        return null;
    var menus = links.map(function (link, index) {
        var attrs = {};
        if (link.onClick) {
            attrs["onClick"] = link.onClick;
        }
        if (link.url) {
            attrs["href"] = link.url;
        }
        return (react_1.default.createElement(react_menu_1.MenuItem, __assign({ key: "menu-item-seq-" + index }, attrs), link.text));
    });
    return (react_1.default.createElement("div", { className: "badge-menu-container" },
        react_1.default.createElement(react_menu_1.Menu, { menuButton: react_1.default.createElement(react_menu_1.MenuButton, { className: "profile-button" },
                react_1.default.createElement("div", { className: "profile-image" },
                    react_1.default.createElement("img", { src: user.imageUrl })),
                react_1.default.createElement("div", { className: "profile-info" },
                    react_1.default.createElement("div", { className: "profile-info-name" }, user.name),
                    react_1.default.createElement("div", { className: "profile-info-username" }, "@todo"))) }, menus)));
};
exports.default = BadgeMenu;
